import { importFiles } from '@randajan/simple-app/fs';
import * as iconsFiles from "./bundle/**";

export const icons = importFiles(iconsFiles, {
    prefix: "./bundle/",
    suffix: ".png",
    trait:(f)=>f.default.slice(1)
});